import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import * as api from '../../api';
import AwardsDisplay from '../../Plateforme/Atoms/AwardsDisplay';
import BoldBlue from '../../Plateforme/Atoms/BoldBlue';
import BigH2 from '../../Plateforme/Atoms/BigH2';
import PressLinksDisplay from '../../Plateforme/Atoms/PressLinksDisplay';
import { FD100MultiSelectOptions } from '../../Plateforme/Utils/Listings';
import Section from '../../Plateforme/Atoms/Section';
import Slider from '../../Plateforme/Components/Slider';
import BlueButton from '../../Plateforme/Atoms/BlueButton';
import JSZip from "jszip";
import FabricantsDisplay from '../../Plateforme/Atoms/FabricantsDisplay';
import styled from 'styled-components';
import Popup from '../../Plateforme/Atoms/Popup';
import Input from '../../Plateforme/Atoms/Input';
import Textarea from '../../Plateforme/Atoms/Textarea';
import Select from '../../Plateforme/Atoms/Select';
import CheckboxPublicPrivate from '../../Plateforme/Atoms/CheckboxPublicPrivate';
import AwardsAdd from '../../Plateforme/Atoms/AwardsAdd';
import PressLinksAdd from '../../Plateforme/Atoms/PressLinksAdd';
import FabricantsAdd from '../../Plateforme/Atoms/FabricantsAdd';
import AdressInput from '../../Plateforme/Atoms/AdressInput';
import {
    DragDropContext,
    Droppable,
    Draggable
} from "react-beautiful-dnd";

// Styled components for edit mode
const EditModeContainer = styled.div`
    margin: 0;
    display: flex;
    align-items: center;
    overflow-x: auto;
    gap: 10px;
    padding: 0 10px;
`;

const MediaItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #eee;
    min-width: 90px;
`;

const MediaPreview = styled.div`
    width: 70px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    img, video {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
    
    .pdf-icon {
        font-size: 30px;
        color: #e74c3c;
    }
`;

const MediaControls = styled.div`
    display: flex;
    gap: 5px;
    margin-top: 5px;
`;

const ActionButton = styled.button`
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 2px 8px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 16px;
    color: black;
    
    &:hover {
        background-color: #e0e0e0;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const RotateButton = styled(ActionButton)`
    background-color: #e6f2ff; 
    &:hover {
        background-color: #cce5ff;
    }
`;

const FDFicheProjet = () => {
    const { i18n } = useTranslation('common');
    const [searchparams] = useSearchParams();
    const [user, setUser] = React.useState(null);
    const [projet, setProjet] = React.useState(null);
    const [isEditMode, setIsEditMode] = React.useState(false);
    const [editedMedias, setEditedMedias] = React.useState([]);
    const [isSaving, setIsSaving] = React.useState(false);
    const [editPopupOpen, setEditPopupOpen] = React.useState(false);
    const [awards, setAwards] = React.useState("");
    const [pressLinks, setPressLinks] = React.useState("");
    const [fabricants, setFabricants] = React.useState("");
    const [type, setType] = React.useState("");
    const [fabrication_fr, setFabrication_fr] = React.useState("");
    const [typologie, setTypologie] = React.useState("");
    const [participation, setParticipation] = React.useState(null);

    //there might be a &mode=jury in the URL, which means we are in jury mode
    const juryMode = searchparams.get("mode") === "jury";

    // Define typology options early to avoid initialization errors
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100(i18n.language);
    const typologieAssiseFD100 = FD100MultiSelectOptions.typologieAssiseFD100(i18n.language);
    const typologieTableFD100 = FD100MultiSelectOptions.typologieTableFD100(i18n.language);
    const typologieLuminaireFD100 = FD100MultiSelectOptions.typologieLuminaireFD100(i18n.language);
    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100(i18n.language);

    // Determine if edit mode is enabled (based on user role or URL param)
    React.useEffect(() => {
        api.GetCurrentUser().then((response) => {
            console.log("current user:");
            console.log(response.data);
            const userLooking = response.data;
            if (userLooking?.role === "admin") {
                setIsEditMode(true);
            }
        }).catch((error) => {
            console.log(error);
        });
    }, [searchparams]);

    // Get user data
    React.useEffect(() => {
        api.GetAllUserData({email: searchparams.get("email"), companyId: searchparams.get("company_id") || undefined}).then((response) => {
            console.log("found user");
            console.log(response.data);
            setUser(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }, [searchparams]);

    // Get participation
    React.useEffect(() => {
        if (!user) return;
        api.getUserParticipations({userid: user.user._id}).then((response) => {
            const _participation = response.data.find((_participation) => _participation._id === searchparams.get("pid"));
            console.log("found participation:");
            console.log(_participation);
            setParticipation(_participation); // Store the participation for later use
            const _projet = _participation.data.projets.find((_projet) => _projet === searchparams.get("projid"));
            const _projetData = user.company.projects.find((_projetData) => _projetData._id === _projet);
            console.log("found projet:");
            console.log(_projetData);
            setProjet(_projetData);
            setEditedMedias(_projetData?.medias || []);
        }).catch((error) => {
            console.log(error);
        });
    }, [user, searchparams]);

    // Initialize edit popup states when project is set
    React.useEffect(() => {
        if (projet && editPopupOpen) {
            setAwards(projet.awards || "");
            setPressLinks(projet.pressLinks || "");
            setFabricants(projet.fabricants || "");
            setType(projet.type || "");
            setFabrication_fr(projet.fabrication_fr || "");
            setTypologie(projet.typologie || "");
        }
    }, [projet, editPopupOpen]);

    // Update typologie when type changes
    React.useEffect(() => {
        if(type === "objet") {
            if (!typologieObjetFD100.find((option) => option.value === typologie)) {
                setTypologie(typologieObjetFD100[0]?.value || "");
            }
        } else if(type === "espace") {
            if (!tyoplogieEspaceFD100.find((option) => option.value === typologie)) {
                setTypologie(tyoplogieEspaceFD100[0]?.value || "");
            }
        }
    }, [type, typologie, typologieObjetFD100, tyoplogieEspaceFD100]);

    // Function to move a media item up in the list
    const moveMediaUp = async (index) => {
        if (index === 0) return;
        setIsSaving(true);
        
        try {
            const newMedias = [...editedMedias];
            const temp = newMedias[index];
            newMedias[index] = newMedias[index - 1];
            newMedias[index - 1] = temp;
            
            setEditedMedias(newMedias);
            
            // Update the project with new medias (simulate API call)
            // In a real implementation, you'd call your API here
            setProjet({
                ...projet,
                medias: newMedias
            });

            api.updateProjectMedias({
                companyId: user.company._id,
                projectId: projet._id,
                medias: newMedias
            }).then((response) => {
                console.log("Project medias updated successfully");
            }).catch((error) => {
                console.error("Error updating project medias:", error);
            });
        } catch (error) {
            console.error("Error reordering media:", error);
        } finally {
            setIsSaving(false);
        }
    };

    // Function to move a media item down in the list
    const moveMediaDown = async (index) => {
        if (index === editedMedias.length - 1) return;
        setIsSaving(true);
        
        try {
            const newMedias = [...editedMedias];
            const temp = newMedias[index];
            newMedias[index] = newMedias[index + 1];
            newMedias[index + 1] = temp;
            
            setEditedMedias(newMedias);
            
            // Update the project with new medias (simulate API call)
            // In a real implementation, you'd call your API here
            setProjet({
                ...projet,
                medias: newMedias
            });

            api.updateProjectMedias({
                companyId: user.company._id,
                projectId: projet._id,
                medias: newMedias
            }).then((response) => {
                console.log("Project medias updated successfully");
            }).catch((error) => {
                console.error("Error updating project medias:", error);
            });
        } catch (error) {
            console.error("Error reordering media:", error);
        } finally {
            setIsSaving(false);
        }
    };

    // Function to rotate an image left (counterclockwise)
    const rotateImageLeft = async (index) => {
        setIsSaving(true);
        const media = {...editedMedias[index]};
        try {
            // Call the API to rotate the image
            const response = await api.rotateImage({ 
                path: media.path,
                direction: 'left'
            });

            console.log("Rotated image response:", response.data);
            
            // Get the cache-busted path from the response
            const newPath = response.data.newPath;
            
            // Update the media path with the cache-busted version
            const newMedias = [...editedMedias];
            
            newMedias[index].path = newPath;

            console.log("New medias:", newMedias);

            api.updateProjectMedias({
                companyId: user.company._id,
                projectId: projet._id,
                medias: newMedias
            }).then((response) => {
                console.log("Project medias updated successfully");
            }).catch((error) => {
                console.error("Error updating project medias:", error);
            });
            
            setEditedMedias(newMedias);
            
            // Update the project with new medias
            setProjet({
                ...projet,
                medias: newMedias
            });
        } catch (error) {
            console.error("Error rotating image:", error);
        } finally {
            setIsSaving(false);
        }
    };
    
    // Function to rotate an image right (clockwise)
    const rotateImageRight = async (index) => {
        setIsSaving(true);
        const media = {...editedMedias[index]};
        try {
            // Call the API to rotate the image
            const response = await api.rotateImage({
                path: media.path,
                direction: 'right'
            });
            
            // Get the cache-busted path from the response
            const newPath = response.data.newPath;
            
            // Update the media path with the cache-busted version
            const newMedias = [...editedMedias];

            newMedias[index].path = newPath;

            api.updateProjectMedias({
                companyId: user.company._id,
                projectId: projet._id,
                medias: newMedias
            }).then((response) => {
                console.log("Project medias updated successfully");
            }).catch((error) => {
                console.error("Error updating project medias:", error);
            });
            
            setEditedMedias(newMedias);
            
            // Update the project with new medias
            setProjet({
                ...projet,
                medias: newMedias
            });
        } catch (error) {
            console.error("Error rotating image:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const renderMediaPreview = (media) => {
        const mediaUrl = process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + media.path;

        if (media.type.includes('image')) {
            return <img src={mediaUrl} alt="" />;
        } else if (media.type.includes('video')) {
            return <video src={mediaUrl} />;
        } else if (media.type.includes('pdf')) {
            // PDF file path looks like this: /userfiles/somekindofid.pdf
            // The image of the preview looks like this: /userfiles/firstpage_somekindofid.png
            const filename = media.path.split('/').pop();
            const pdfPreviewPath = media.path.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');
            return <img src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + pdfPreviewPath} alt="" />;
        } else {
            return <div className="pdf-icon">📄</div>;
        }
    };

    function echelleCodeToLabel(code) {
        if (code === "industrielle") return i18n.language === "fr" ? "Industrielle" : "Industrial";
        if (code === "edition_limitee") return i18n.language === "fr" ? "Edition limitée" : "Limited edition";
        if (code === "piece_unique") return i18n.language === "fr" ? "Pièce unique" : "Single piece";
    }

    function paysCodeToLabel(code) {
        if (code === "europe") return i18n.language === "fr" ? "Europe" : "Europe";
        if (code === "grand_export") return i18n.language === "fr" ? "Grand Export" : "Grand Export";
    }

    function sanitizeFileName(fileName) {
        return fileName.trim().replace(/[\.\#\%\&\{\}\<\>\*\?\/\$\!\'\"\:\@\+\\|\=]/g, "_");
    }

    const downloadAllMedia = async () => {
        const zip = new JSZip();
    
        for (const media of projet.medias) {
            const { fileName, credit, path } = media;
    
            // Determine the file extension
            const extension = fileName.split('.').pop();
            const index = projet.medias.indexOf(media);
            const projectName = i18n.language !== 'fr' && projet.name_en ? projet.name_en : projet.name;
            const zipFileName = sanitizeFileName(`${projectName} - média ${index + 1} - ${credit || ""}`)+`.${extension}`;
    
            try {
                // Fetch the file from the server or any accessible location
                const response = await fetch(process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + path);
                if (!response.ok) {
                    throw new Error(`Failed to fetch file: ${path}`);
                }
                const blob = await response.blob();
    
                // Add the file to the zip
                zip.file(zipFileName, blob);
            } catch (error) {
                console.error(`Error fetching file ${path}:`, error);
            }
        }
    
        // Generate the zip file
        const zipBlob = await zip.generateAsync({ type: "blob" });
    
        // Trigger the download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(zipBlob);
        const projectName = i18n.language !== 'fr' && projet.name_en ? projet.name_en : projet.name;
        link.download = sanitizeFileName(projectName) + ".zip";
        link.click();
    
        // Clean up the object URL
        URL.revokeObjectURL(link.href);
    };
    
    const onDragEnd = (result) => {
        const { source, destination } = result;
    
        if (!destination || source.index === destination.index) return;
    
        const newMedias = Array.from(editedMedias);
        const [moved] = newMedias.splice(source.index, 1);
        newMedias.splice(destination.index, 0, moved);
    
        setEditedMedias(newMedias);
        setProjet({
            ...projet,
            medias: newMedias
        });
    
        api.updateProjectMedias({
            companyId: user.company._id,
            projectId: projet._id,
            medias: newMedias
        }).then(() => {
            console.log("Project medias updated successfully");
        }).catch((error) => {
            console.error("Error updating project medias:", error);
        });
    };
    
    const saveEditedProject = async () => {
        const divContainingTheFields = document.querySelector(".editProjectPopupInner");
        const fields = Array.from(divContainingTheFields.querySelectorAll("input, textarea, select"));

        try {
            setIsSaving(true);

            // Update the entire participation with the modified project
            if (participation && participation.data) {
                // Build the updated project object with FD1002025 structure
                const updatedProject = {
                    name: fields.find((field) => field.name === "nom_projet")?.value,
                    name_en: fields.find((field) => field.name === "nom_projet_en")?.value,
                    aboutfr: fields.find((field) => field.name === "description_francais")?.value,
                    abouten: fields.find((field) => field.name === "description_anglais")?.value,
                    awards: awards || "",
                    lien_presse: pressLinks || "",
                    fabricants: fabricants || "",
                    public: fields.find((field) => field.name === "public").checked,
                    autorisation: true, // Always true for existing projects
                    year: fields.find((field) => field.name === "annee_projet")?.value,
                    type: fields.find((field) => field.name === "type")?.value,
                    unique_collection: fields.find((field) => field.name === "unique_collection")?.value,
                    typologie: fields.find((field) => field.name === "typologie")?.value,
                    typologieAssise: fields.find((field) => field.name === "typologieAssise")?.value,
                    typologieTable: fields.find((field) => field.name === "typologieTable")?.value,
                    typologieLuminaire: fields.find((field) => field.name === "typologieLuminaire")?.value,
                    autre_typologie: fields.find((field) => field.name === "autre_typologie")?.value,
                    adresse: fields.find((field) => field.name === "adresse")?.value,
                    latitude: fields.find((field) => field.name === "latitude")?.value,
                    longitude: fields.find((field) => field.name === "longitude")?.value,
                    fabrication_fr: fields.find((field) => field.name === "fabrication_fr")?.value,
                    communiquer_fabricants: fields.find((field) => field.name === "communiquer_fabricants")?.value,
                    editeur: fields.find((field) => field.name === "editeur")?.value,
                    distributeur: fields.find((field) => field.name === "distributeur")?.value,
                    pays_distribution: fields.find((field) => field.name === "pays_distribution")?.value,
                    echelle_production: fields.find((field) => field.name === "echelle_production")?.value,
                    id_in_participation: searchparams.get("projid"), // Keep the original participation project ID
                    id_in_company: projet._id,
                    medias: projet.medias || [],
                    newMedias: [], // No new medias in this edit
                    mediasToDelete: [] // No medias to delete in this edit
                };

                // Get the current projects from participation data
                const currentProjects = participation.data.projets || [];

                // Build the updated projects array
                const updatedProjects = [];
                for (let projId of currentProjects) {
                    if (projId === searchparams.get("projid")) {
                        // This is the project we're updating
                        updatedProjects.push(updatedProject);
                    } else {
                        // For other projects, find them in company projects
                        const otherProject = user.company.projects.find(p => p._id === projId);
                        if (otherProject) {
                            updatedProjects.push({
                                ...otherProject,
                                awards: otherProject.awards || "",
                                lien_presse: otherProject.pressLinks || "",
                                fabricants: otherProject.fabricants || "",
                                autorisation: true,
                                id_in_participation: projId,
                                id_in_company: otherProject._id,
                                newMedias: [],
                                mediasToDelete: []
                            });
                        }
                    }
                }

                // Prepare the submission data for saveFD1002025
                const submission = new FormData();

                // Add all the participation form data (contact info, culture_francaise, etc.)
                const formFields = ['culture_francaise', 'contact_nom', 'contact_prenom', 'contact_mail', 'contact_telephone'];
                formFields.forEach(field => {
                    if (participation.data[field]) {
                        submission.append(field, participation.data[field]);
                    }
                });

                // Add any other form fields that might exist
                if (participation.data.form) {
                    Object.keys(participation.data.form).forEach(key => {
                        if (!formFields.includes(key)) {
                            submission.append(key, participation.data.form[key]);
                        }
                    });
                }

                // Add the updated projects as JSON string
                submission.append("projets", JSON.stringify(updatedProjects));

                // Add required fields for saveFD1002025
                submission.append("userId", user.user._id);
                submission.append("eventId", participation.eventId || participation.event || participation.data.eventId);
                submission.append("_id", participation._id); // Use _id for the participation ID

                // Log to debug
                console.log("Participation object:", participation);
                console.log("Event ID being sent:", participation.eventId || participation.event || participation.data.eventId);

                // Save the entire participation with the updated project
                await api.saveFD1002025(submission);
            }

            setEditPopupOpen(false);
            window.location.reload();
        } catch (error) {
            console.error("Error updating project:", error);
            alert(i18n.language === "fr" ? "Erreur lors de la mise à jour du projet" : "Error updating project");
        } finally {
            setIsSaving(false);
        }
    };

    const shouldAddFabricants = () => type === "objet" || (type === "espace" && fabrication_fr === "oui");

    const renderEditModeUI = () => {
        if (!isEditMode || !editedMedias.length) return null;
    
        return (
            <EditModeContainer>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="medias-droppable" direction="horizontal">
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{ display: "flex", gap: "1rem" }}
                            >
                                {editedMedias.map((media, index) => (
                                    <Draggable key={index} draggableId={`media-${index}`} index={index}>
                                        {(provided) => (
                                            <MediaItemContainer
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <MediaPreview>
                                                    {renderMediaPreview(media)}
                                                </MediaPreview>
    
                                                <MediaControls>
                                                    {media.type.includes("image") && (
                                                        <>
                                                            <RotateButton
                                                                onClick={() => rotateImageLeft(index)}
                                                                disabled={isSaving}
                                                                title={i18n.language === "fr" ? "Pivoter à gauche" : "Rotate left"}
                                                            >
                                                                ↺
                                                            </RotateButton>
    
                                                            <RotateButton
                                                                onClick={() => rotateImageRight(index)}
                                                                disabled={isSaving}
                                                                title={i18n.language === "fr" ? "Pivoter à droite" : "Rotate right"}
                                                            >
                                                                ↻
                                                            </RotateButton>
                                                        </>
                                                    )}
                                                </MediaControls>
                                            </MediaItemContainer>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </EditModeContainer>
        );
    };
    
    return (
        <div>
            {projet && 
                <div>
                    <Section className="padding" style={{position: 'relative'}}>
                        <BigH2 style={{textTransform:"uppercase"}}>{i18n.language !== 'fr' && projet.name_en ? projet.name_en : projet.name}</BigH2>
                        {isEditMode && (
                            <BlueButton
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}
                                onClick={() => setEditPopupOpen(true)}
                            >
                                {i18n.language === "fr" ? "Modifier le projet" : "Edit project"}
                            </BlueButton>
                        )}
                    </Section>
                    <Section className="padding">
                        {isEditMode && <div className='centered'>
                            <BlueButton onClick={() => downloadAllMedia()}>
                                {i18n.language === "fr" ? "Télécharger tous les médias" : "Download all media"}
                            </BlueButton>
                            <br/><br/>
                        </div>}
                        <Slider
                            slides={isEditMode ? editedMedias : projet.medias}
                        />
                        {/* Render edit mode UI below the slider */}
                        {renderEditModeUI()}
                    </Section>
                    <Section className="padding">
                        <BoldBlue>{i18n.language === "fr" ? "Présentation du projet" : "Project presentation"}</BoldBlue><br/>
                        <p style={{whiteSpace:'pre-wrap'}}>{i18n.language === "fr" ? projet.aboutfr : projet.abouten}</p><br/>
                        <AwardsDisplay
                            awards={projet.awards}
                        />
                        <br/>
                        <PressLinksDisplay
                            pressLinks={projet.pressLinks}
                        />
                        {!juryMode && <><BoldBlue>{i18n.language === "fr" ? "J'autorise Le FRENCH DESIGN by VIA à rendre public ce projet dans mon portfolio auprès des différents membres de la communauté" : "I authorise Le FRENCH DESIGN to share this project in my portfolio with the various members of the community"} </BoldBlue><br/>
                        <span>{projet.public ? (i18n.language === "fr" ? "Oui" : "Yes") : (i18n.language === "fr" ? "Non" : "No")}</span>
                        <br/><br/></>}
                        {!juryMode && <><BoldBlue>{i18n.language === "fr" ? "Je certifie avoir l'autorisation de communiquer sur le projet au moment de la révélation du prix" : "I hereby confirm that I have permission to communicate about the project at the time of the award announcement"}</BoldBlue><br/>
                        <span>{i18n.language === "fr" ? "Oui" : "Yes"}</span>
                        <br/><br/></>}
                        <BoldBlue>{i18n.language === "fr" ? "Année du projet" : "Year of the project"}</BoldBlue><br/>
                        <span>{projet.year}</span>
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Type de projet" : "Type of project"}</BoldBlue><br/>
                        <span className="capitalized">{projet.type === 'objet' ? (i18n.language === "fr" ? "Objet" : "Object") : (i18n.language === "fr" ? "Espace" : "Space")}</span>
                        <br/><br/>
                        {projet.type === "objet" && <>
                            <BoldBlue>{i18n.language === "fr" ? "S'agit-il d'une seule pièce ou d'une collection ?" : "Is it a single piece or a collection?"}</BoldBlue><br/>
                            <span className="capitalized">{projet.unique_collection}</span>
                            <br/><br/>
                            <BoldBlue>{i18n.language === "fr" ? "Typologie" : "Type"}</BoldBlue><br/>
                            <span>{typologieObjetFD100.find((cat) => cat.value === projet.typologie)?.label}</span>
                            <br/><br/>
                            {projet.typologie === "assise" && <>
                                <BoldBlue>{i18n.language === "fr" ? "Type assise" : "Seating type"}</BoldBlue><br/>
                                <span>{typologieAssiseFD100.find((cat) => cat.value === projet.typologieAssise)?.label}</span>
                                <br/><br/>
                            </>}
                            {projet.typologie === "table" && <>
                                <BoldBlue>{i18n.language === "fr" ? "Typet table" : "Table type"}</BoldBlue><br/>
                                <span>{typologieTableFD100.find((cat) => cat.value === projet.typologieTable)?.label}</span>
                                <br/><br/>
                            </>}
                            {projet.typologie === "luminaire" && <>
                                <BoldBlue>{i18n.language === "fr" ? "Type luminaire" : "Lighting type"}</BoldBlue><br/>
                                <span>{typologieLuminaireFD100.find((cat) => cat.value === projet.typologieLuminaire)?.label}</span>
                                <br/><br/>
                            </>}
                            <BoldBlue>{i18n.language === "fr" ? "Echelle de production de votre pièce/collection" : "Production scale of your piece/collection"}</BoldBlue><br/>
                            <span>{echelleCodeToLabel(projet.echelle_production)}</span>
                            <br/><br/>
                            {projet.editeur && <><BoldBlue>{i18n.language === "fr" ? "Nom de l'éditeur" : "Publisher name"}</BoldBlue><br/>
                            <span className="capitalized">{projet.editeur}</span>
                            <br/><br/></>}
                            <BoldBlue>{i18n.language === "fr" ? "Nom du distributeur" : "Distributor name"}</BoldBlue><br/>
                            <span className="capitalized">{projet.distributeur}</span>
                            <br/><br/>
                            <BoldBlue>{i18n.language === "fr" ? "Pays de distribution" : "Distribution country"}</BoldBlue><br/>
                            <span>{paysCodeToLabel(projet.pays_distribution)}</span>
                            <br/><br/>
                        </>}

                        {projet.type === "espace" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Typologie" : "Typology"}</BoldBlue><br/>
                            <span>{tyoplogieEspaceFD100.find((cat) => cat.value === projet.typologie)?.label}</span>
                            <br/><br/>
                            <BoldBlue>{i18n.language === "fr" ? "Adresse du projet" : "Project address"}</BoldBlue><br/>
                            <span>{projet.adresse}</span>
                            <br/><br/>
                        </>}

                        <BoldBlue>{i18n.language === "fr" ? "Votre projet fait-il appel à la fabrication française ?" : "Does your project involve French manufacturing?"}</BoldBlue><br/>
                        <span className="capitalized">{projet.fabrication_fr === "oui" ? (i18n.language === "fr" ? "Oui" : "Yes") : (i18n.language === "fr" ? "Non" : "No")}</span>
                        <br/><br/>
                        {projet.fabrication_fr === "oui" && <>
                            <FabricantsDisplay
                                fabricants={projet.fabricants}
                            />
                            {!juryMode && <><BoldBlue>{i18n.language === "fr" ? "Souhaitez-vous communiquer sur les fabricants qui ont travaillé sur votre projet ?" : "Do you want to communicate about the manufacturers who worked on your project?"}</BoldBlue><br/>
                            <span className="capitalized">{projet.communiquer_fabricants}</span><br/><br/></>}
                        </>}
                    </Section>
                </div>
            }
            {editPopupOpen && projet && (
                <Popup style={{maxWidth:"calc(min(100vw,800px) - 20px)",padding:"32px 0"}} close={() => setEditPopupOpen(false)}>
                    <div style={{overflow:"scroll", maxHeight:"calc(100vh - 20px)", width:"100%",padding:"0 32px"}} className="editProjectPopupInner">
                        <BoldBlue>{i18n.language === "fr" ? "Nom du projet en français*" : "Project name in French*"}</BoldBlue>
                        <Input required name="nom_projet" style={{width:'100%',fontSize:'35px',fontWeight:'600'}} placeholder={i18n.language === "fr" ? "Nom du projet en français" : "Project name in French"} defaultValue={projet?.name} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Nom du projet en anglais*" : "Project name in English*"}</BoldBlue>
                        <Input required name="nom_projet_en" style={{width:'100%',fontSize:'35px',fontWeight:'600'}} placeholder={i18n.language === "fr" ? "Nom du projet en anglais" : "Project name in English"} defaultValue={projet?.name_en} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Description du projet en français*" : "Project description in French*"}</BoldBlue>
                        <Textarea required name="description_francais" style={{ width: '100%'}} placeholder={i18n.language === "fr" ? "Description du projet en français" : "Project description in French"} defaultValue={projet?.aboutfr} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Description du projet en anglais*" : "Project description in English*"}</BoldBlue>
                        <Textarea required name="description_anglais" style={{ width: '100%'}} placeholder={i18n.language === "fr" ? "Description du projet en anglais" : "Project description in English"} defaultValue={projet?.abouten} />
                        <br/><br/>
                        <AwardsDisplay
                            inputName="awards"
                            awards={awards}
                            setAwards={setAwards}
                        />
                        <br/>
                        <AwardsAdd
                            awards={awards}
                            setAwards={setAwards}
                        />
                        <br/>
                        <PressLinksDisplay
                            inputName="lien_presse"
                            pressLinks={pressLinks}
                            setPressLinks={setPressLinks}
                        />
                        <PressLinksAdd
                            pressLinks={pressLinks}
                            setPressLinks={setPressLinks}
                        />
                        <br/>
                        <BoldBlue>{i18n.language === "fr" ? "Année du projet" : "Project year"}</BoldBlue>
                        <Select name="annee_projet" style={{width:"100%"}} defaultValue={projet?.year}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une année*" : "Select a year*"}</option>
                            {[...Array(13)].map((_, i) => (
                                <option key={2024 + i} value={2024 + i}>{2024 + i}</option>
                            ))}
                        </Select>
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Type de projet*" : "Project type*"}</BoldBlue><br/>
                        <Select name="type" style={{width:"100%"}} defaultValue={projet?.type} onChange={(event) => setType(event.target.value)}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez un type de projet" : "Select a project type"}</option>
                            <option value="objet">{i18n.language === "fr" ? "Objet" : "Object"}</option>
                            <option value="espace">{i18n.language === "fr" ? "Espace" : "Space"}</option>
                        </Select>
                        <br/><br/>
                        {type === "objet" && (
                            <>
                                <BoldBlue>{i18n.language === "fr" ? "S'agit-il d'une seule pièce ou d'une collection ? *" : "Is it a single piece or a collection? *"}</BoldBlue>
                                <Select name="unique_collection" style={{width:"100%"}} defaultValue={projet?.unique_collection}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                                    <option value="unique">{i18n.language === "fr" ? "Pièce unique" : "Single piece"}</option>
                                    <option value="collection">{i18n.language === "fr" ? "Collection" : "Collection"}</option>
                                </Select>
                                <br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Typologie*" : "Typology*"}</BoldBlue>
                                <Select name="typologie" style={{width:"100%"}} defaultValue={projet?.typologie} onChange={(event) => setTypologie(event.target.value)}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie" : "Select a typology"}</option>
                                    {typologieObjetFD100.map((option) => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </Select>
                                {typologie === "autre" &&
                                    <Input required name="autre_typologie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Veuillez préciser" : "Please specify"}  defaultValue={projet?.autre_typologie}/>
                                }
                                <br/><br/>
                                {typologie === "assise" && (
                                    <>
                                        <BoldBlue>{i18n.language === "fr" ? "Assise*" : "Seating*"}</BoldBlue>
                                        <Select name="typologieAssise" style={{width:"100%"}} defaultValue={projet?.typologieAssise}>
                                            <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie d'assise" : "Select a seating typology"}</option>
                                            {typologieAssiseFD100.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </Select>
                                        <br/><br/>
                                    </>
                                )}
                                {typologie === "table" && (
                                    <>
                                        <BoldBlue>{i18n.language === "fr" ? "Table*" : "Table*"}</BoldBlue>
                                        <Select name="typologieTable" style={{width:"100%"}} defaultValue={projet?.typologieTable}>
                                            <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie de table" : "Select a table typology"}</option>
                                            {typologieTableFD100.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </Select>
                                        <br/><br/>
                                    </>
                                )}
                                {typologie === "luminaire" && (
                                    <>
                                        <BoldBlue>{i18n.language === "fr" ? "Luminaire*" : "Lighting*"}</BoldBlue>
                                        <Select name="typologieLuminaire" style={{width:"100%"}} defaultValue={projet?.typologieLuminaire}>
                                            <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie de luminaire" : "Select a lighting typology"}</option>
                                            {typologieLuminaireFD100.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </Select>
                                        <br/><br/>
                                    </>
                                )}
                                <BoldBlue>{i18n.language === "fr" ? "Echelle de production de votre pièce/collection*" : "Production scale of your piece/collection*"}</BoldBlue>
                                <Select name="echelle_production" style={{width:"100%"}} defaultValue={projet?.echelle_production}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez une échelle de production" : "Select a production scale"}</option>
                                    <option value="industrielle">{i18n.language === "fr" ? "Industrielle" : "Industrial"}</option>
                                    <option value="edition_limitee">{i18n.language === "fr" ? "Edition limitée" : "Limited edition"}</option>
                                    <option value="piece_unique">{i18n.language === "fr" ? "Pièce unique" : "Single piece"}</option>
                                </Select>
                                <br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Nom de l'éditeur*" : "Publisher name*"}</BoldBlue>
                                <Input required name="editeur" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom de l'éditeur" : "Publisher name"} defaultValue={projet?.editeur} />
                                <br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Nom du distributeur*" : "Distributor name*"}</BoldBlue>
                                <Input required name="distributeur" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom du distributeur" : "Distributor name"} defaultValue={projet?.distributeur} />
                                <br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Pays de distribution*" : "Distribution country*"}</BoldBlue>
                                <Select name="pays_distribution" style={{width:"100%"}} defaultValue={projet?.pays_distribution}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez un pays de distribution" : "Select a distribution country"}</option>
                                    <option value="europe">{i18n.language === "fr" ? "Europe" : "Europe"}</option>
                                    <option value="grand_export">{i18n.language === "fr" ? "Grand Export" : "Grand Export"}</option>
                                </Select>
                                <br/><br/>
                            </>
                        )}
                        {type === "espace" && (
                            <>
                                <BoldBlue>{i18n.language === "fr" ? "Typologie*" : "Typology*"}</BoldBlue>
                                <Select name="typologie" style={{width:"100%"}} defaultValue={projet?.typologie}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie" : "Select a typology"}</option>
                                    {tyoplogieEspaceFD100.map((option) => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </Select>
                                {typologie === "autre" &&
                                    <Input required name="autre_typologie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Veuillez préciser" : "Please specify"}  defaultValue={projet?.autre_typologie}/>
                                }
                                <br/><br/>
                                <BoldBlue>{i18n.language === "fr" ? "Adresse du projet *" : "Project address*"}</BoldBlue>
                                <AdressInput
                                    adressDefaultValue={projet?.adresse}
                                    latitudeDefaultValue={projet?.latitude}
                                    longitudeDefaultValue={projet?.longitude}
                                    required
                                    placeholder={i18n.language === "fr" ? "Adresse du projet" : "Project address"}
                                    adressInputName="adresse"
                                    latitutdeInputName="latitude"
                                    longitudeInputName="longitude"
                                />
                                <br/><br/>
                            </>
                        )}
                        <BoldBlue>{i18n.language === "fr" ? "Votre projet fait-il appel à la fabrication française ?*" : "Does your project involve French manufacturing?*"}</BoldBlue>
                        <Select name="fabrication_fr" style={{width:"100%"}} defaultValue={projet?.fabrication_fr} onChange={(event) => setFabrication_fr(event.target.value)}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>
                        <br/><br/>
                        {shouldAddFabricants() && (
                            <>
                                <FabricantsDisplay
                                    inputName="fabricants"
                                    fabricants={fabricants}
                                    setFabricants={setFabricants}
                                />
                                <FabricantsAdd
                                    fabricants={fabricants}
                                    setFabricants={setFabricants}
                                    required
                                />
                                <br/><br/>
                            </>
                        )}
                        {fabrication_fr === "oui" && (
                            <>
                                <BoldBlue>{i18n.language === "fr" ? "Autorisez vous Le FRENCH DESIGN à communiquer sur les fabricants qui ont travaillé sur votre projet? *" : "Do you authorize Le FRENCH DESIGN to communicate about the manufacturers who worked on your project? *"}</BoldBlue>
                                <Select name="communiquer_fabricants" style={{width:"100%"}} defaultValue={projet?.communiquer_fabricants}>
                                    <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                                    <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                                    <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                                </Select>
                                <br/><br/>
                            </>
                        )}
                        <div className="flexblock" style={{marginTop:"20px"}}>
                            <span>{i18n.language === "fr" ? "J'autorise Le FRENCH DESIGN by VIA à rendre public ce projet dans mon portfolio auprès des différents membres de la communauté* :" : "I authorize Le FRENCH DESIGN by VIA to make this project public in my portfolio to the various members of the community*:"}</span>
                            <CheckboxPublicPrivate name="public" defaultChecked={projet?.public ? "on" : "off"}/>
                        </div>
                        <br/><br/>
                        <div className="flexblock" style={{display:"flex", justifyContent:"space-between", gap:"20px", flexWrap:"wrap", marginBottom:"40px", alignItems:"center"}}>
                            <BlueButton type="button" style={{padding:"12px 20px"}} onClick={() => setEditPopupOpen(false)}>
                                {i18n.language === "fr" ? "Annuler" : "Cancel"}
                            </BlueButton>
                            <BlueButton type="button" style={{padding:"12px 20px"}} onClick={saveEditedProject} disabled={isSaving}>
                                {isSaving ? (i18n.language === "fr" ? "Enregistrement..." : "Saving...") : (i18n.language === "fr" ? "Enregistrer" : "Save")}
                            </BlueButton>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
};

export default FDFicheProjet;